export default class SimpleArgsClassPreview {
  constructor() {}
}
